<script setup lang="ts">
import Chip from 'primevue/chip';
import { computed } from 'vue'

const { active } = defineProps<{
  active?: boolean
}>();

const chipClass = computed(() => [
  'input-text',
  active ? 'active-chip' : 'inactive-chip'
]);

</script>

<template>

  <Chip v-bind="$attrs"
        :class="active ? 'input-text active-chip' : 'input-text inactive-chip'" >
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}"></slot>
    </template>
    <template v-if="active" #icon>
      <i class="pi pi-check"  />
    </template>
    <template #removeicon="{ removeCallback, keydownCallback }">
      <div class="fucking-custom-class-i-wanna-kil-myself"
           @click="removeCallback" @keydown="keydownCallback"
      >
        <i class="pi pi-times i-dont-know-why-dt-pt-not-working"  />
      </div>
    </template>
    <slot />
  </Chip>
</template>

<style scoped>
.p-chip:hover {
  background: var(--active-20);
  border-color: var(--active-20);
}

.input-text {
  cursor: pointer;
  border: 1px solid var(--grey-100);
}

.active-chip {
  background: var(--active-100) !important;
  color: var(--white-100) !important;
}

.inactive-chip {
  background: var(--white-100);
  color: var(--active-100);
}

.i-dont-know-why-dt-pt-not-working {
  color: var(--primary-blue-60);
}

.fucking-custom-class-i-wanna-kil-myself {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}

.fucking-custom-class-i-wanna-kil-myself:hover {
  background: var(--primary-blue-10);
}

</style>